/**
 * Boolean fields should default to false to prevent:
 * - `undefined` in formik state
 * - Show correct value when voucherRule exists
 *   -  Backend is_active == false, but default is true, then it will display as true
 *
 * @param {object} voucherRule - object representing a Customer::Cart::Voucher::Rule
 * @returns
 */
export const initialValues = (voucherRule) => {
  const isEdit                 = Object.keys(voucherRule).length > 0
  const non_marketing_discount = voucherRule?.product_rules?.some((rule) => rule.code == 'is_marketing_discount')

  return ({
    name        : voucherRule?.name || '',
    description : voucherRule?.description || '',
    terms       : voucherRule?.terms || 'Setiap pembelanjaan dengan voucher hanya berlaku pada www.tinkerlust.com ',
    category    : voucherRule?.category || '',

    is_active           : voucherRule?.is_active || false,
    show_on_checkout    : voucherRule?.show_on_checkout || false,
    device              : voucherRule?.device || 'all',
    is_for_new_customer : voucherRule?.is_for_new_customer || false,
    is_refundable       : voucherRule?.is_refundable || false,

    from_date : voucherRule?.from_date || '',
    to_date   : voucherRule?.to_date || '',

    is_hour_limit   : voucherRule?.is_hour_limit || false,
    hour_limit_from : voucherRule?.hour_limit_from || '',
    hour_limit_to   : voucherRule?.hour_limit_to || '',
    is_day_limit    : voucherRule?.is_day_limit || false,
    day_limit       : voucherRule?.day_limit || '',

    is_shipment_discount_active      : voucherRule?.is_shipment_discount_active || false,
    shipment_discount_type           : voucherRule?.shipment_discount_type || 'absolute',
    shipment_discount_absolute       : voucherRule?.shipment_discount_absolute || 0,
    shipment_discount_percentage     : voucherRule?.shipment_discount_percentage || 0,
    shipment_discount_percentage_max : voucherRule?.shipment_discount_percentage_max || 0,

    is_item_discount_active      : voucherRule?.is_item_discount_active || false,
    item_discount_type           : voucherRule?.item_discount_type || 'absolute',
    item_discount_absolute       : voucherRule?.item_discount_absolute || 0,
    item_discount_percentage     : voucherRule?.item_discount_percentage || 0,
    item_discount_percentage_max : voucherRule?.item_discount_percentage_max || 0,

    // backend will be removing this column
    conditions: voucherRule?.conditions || {
      product_attributes : voucherRule?.conditions?.product_attributes || [],
      cart_attributes    : voucherRule?.conditions?.cart_attributes || []
    },

    cart_rules             : voucherRule?.cart_rules || [],
    non_marketing_discount : isEdit ? non_marketing_discount : true,
    product_rules          : isEdit ? voucherRule?.product_rules : [ non_marketing_discount_rule ],

    /**
     * Plural `vouchers` to follow Rails accepted_nested_attributes
     *   {
     *     code             : string ,
     *     use_per_customer : number,
     *     usage_limit      : number
     *   }
     */
    vouchers_attributes: voucherRule?.voucher_attributes || []
  })
}

export const non_marketing_discount_rule = {
  code     : 'is_marketing_discount',
  operator : '=',
  value    : false
}
